/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OrganizationsControllerFindOwnersQueryResponse, OrganizationsControllerFindOwnersQueryParams } from "../../models/organizationsController/OrganizationsControllerFindOwners";

function getOrganizationsControllerFindOwnersUrl() {
  const res = { method: 'GET', url: `/api/v1/organizations/owners` as const }  
  return res
}

/**
 * @summary Get organization owners/admins for organizations
 * {@link /api/v1/organizations/owners}
 */
export async function organizationsControllerFindOwners(params: OrganizationsControllerFindOwnersQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<OrganizationsControllerFindOwnersQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getOrganizationsControllerFindOwnersUrl().url.toString(), params, ... requestConfig })  
  return res.data
}